import script from "./Links.vue?vue&type=script&setup=true&lang=js"
export * from "./Links.vue?vue&type=script&setup=true&lang=js"

import "./Links.vue?vue&type=style&index=0&id=463e87e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463e87e4"]])

export default __exports__